var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"custom-icon-exclamation"},[(_vm.isSelectAllOptionForFilter)?_c('span',[_vm._v("(Select All)")]):(_vm.isStopSale)?_c('OctagonX',{staticClass:"stop-sale-icon",attrs:{"size":_vm.isCompact ? 16 : 20}}):_c('span',[_vm._v("-")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }